import React from "react";
import storage from "../../../../Storage";
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Deposit from "./Deposit";
import Withdrawl from "./Withdrawl";
import History from "./History";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={1}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
}));

function Wallet({ initialTab }) {
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = React.useState(initialTab || 0);

    React.useEffect(() => {
        if (initialTab !== undefined) {
            setValue(initialTab);
        }
    }, [initialTab]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const name = storage.getKey('name') || 'User';
    const phone = storage.getKey('email') || 'N/A';

    return (
        <div className={classes.root}>
            <div className="wallet-profile-header">
                <div className="wallet-avatar-wrapper">
                    <div className="wallet-avatar-placeholder">
                        <i className="mdi mdi-account" />
                    </div>
                </div>
                <div className="wallet-user-details">
                    <h5 className="wallet-user-name">{name}</h5>
                    <p className="wallet-user-phone">
                        <i className="mdi mdi-cellphone" />
                        {phone}
                    </p>
                </div>
            </div>
            <div className="wallet-tabs-container">
                <div
                    className={`wallet-tab-btn ${value === 0 ? 'active' : ''}`}
                    onClick={() => setValue(0)}
                >
                    <i className="mdi mdi-download" />
                    <span>Deposit</span>
                </div>
                <div
                    className={`wallet-tab-btn ${value === 1 ? 'active' : ''}`}
                    onClick={() => setValue(1)}
                >
                    <i className="mdi mdi-upload" />
                    <span>Withdraw</span>
                </div>
                <div
                    className={`wallet-tab-btn ${value === 2 ? 'active' : ''}`}
                    onClick={() => setValue(2)}
                >
                    <i className="mdi mdi-history" />
                    <span>History</span>
                </div>
            </div>
            <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={value}
                onChangeIndex={handleChangeIndex}
            >
                <TabPanel value={value} index={0} dir={theme.direction}>
                    <Deposit />
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                    <Withdrawl />
                </TabPanel>
                <TabPanel value={value} index={2} dir={theme.direction}>
                    <History />
                </TabPanel>
            </SwipeableViews>
        </div>
    );
}

Wallet.propTypes = {
    initialTab: PropTypes.number,
};

export default Wallet;